import { useUserPermissions } from "@src/presentation/hooks/permissions";
import type { ReactNode } from "react";
import AppRoutesGuardError from "./AppRoutes.guard.error";
interface AppRoutesGuardProps {
  children: ReactNode;
  requiredPermissions: string[];
  checkMode?: "any" | "all";
}

export const AppRoutesGuard = ({
  children,
  requiredPermissions,
  checkMode = "any",
}: AppRoutesGuardProps) => {
  const { hasAnyPermission, hasAllPermissions } = useUserPermissions();
  if (checkMode === "all" && !hasAllPermissions(requiredPermissions)) {
    return <AppRoutesGuardError />;
  }

  if (checkMode === "any" && !hasAnyPermission(requiredPermissions)) {
    return <AppRoutesGuardError />;
  }

  return children;
};
